import styles from "./PortfolioSection.module.css";
import ecommercy from "../../assets/ecommercy.png";
import event from "../../assets/event.png";
import kanban from "../../assets/kanban.png";
import bankist from "../../assets/bankist.png";
import mapty from "../../assets/mapty.png";
import expenses from "../../assets/expenses.png";
import Button from "../UI/Button";

const PortfolioSection = () => {
  return (
    <section className={styles.sec} id="portofolio">
      <h2>
        <span>Portfolio</span>
      </h2>

      <div className={styles.container}>
        <div className={styles.feature}>
          <p className={styles.title}>E-commercie App</p>
          <img src={ecommercy} alt="img" />
          <div className={styles.buttonContainer}>
            <Button
              color="red"
              href="https://express-rest-k3bi.onrender.com/"
              target="_blank"
            >
              Live demo
            </Button>
            <Button
              href="https://github.com/Mohamed1442/expressjs-app"
              target="_blank"
            >
              Source code
            </Button>
          </div>
        </div>
        <div className={styles.feature}>
          <p className={styles.title}>Events App</p>
          <img src={event} alt="img" />
          <div className={styles.buttonContainer}>
            <Button
              color="red"
              href="https://event-app-11.netlify.app/"
              target="_blank"
            >
              Live demo
            </Button>
            <Button
              href="https://github.com/Mohamed1442/Event-app"
              target="_blank"
            >
              Source code
            </Button>
          </div>
        </div>
        <div className={styles.feature}>
          <p className={styles.title}>kanban-board</p>
          <img src={kanban} alt="img" />
          <div className={styles.buttonContainer}>
            <Button
              color="red"
              href="https://kanban-board-v1.netlify.app/"
              target="_blank"
            >
              Live demo
            </Button>
            <Button
              href="https://github.com/Mohamed1442/Kanban-Board/tree/main"
              target="_blank"
            >
              Source code
            </Button>
          </div>
        </div>
        <div className={styles.feature}>
          <p className={styles.title}>Bankist App</p>
          <img src={bankist} alt="img" />
          <div className={styles.buttonContainer}>
            <Button
              color="red"
              href="https://bankist-site-mohamedmagdy.netlify.app/"
              target="_blank"
            >
              Live demo
            </Button>
            <Button
              href="https://github.com/Mohamed1442/Kalbonyan-Elmarsos/tree/main/02-Udemy/-02-Js-Jonas/Projects/Bankist"
              target="_blank"
            >
              Source code
            </Button>
          </div>
        </div>
        <div className={styles.feature}>
          <p className={styles.title}>Mapty App</p>
          <img src={mapty} alt="img" />
          <div className={styles.buttonContainer}>
            <Button
              color="red"
              href="https://mapty-app-mohamedmagdy.netlify.app/"
              target="_blank"
            >
              Live demo
            </Button>
            <Button
              href="https://github.com/Mohamed1442/Kalbonyan-Elmarsos/tree/main/02-Udemy/-02-Js-Jonas/Projects/Mapty"
              target="_blank"
            >
              Source code
            </Button>
          </div>
        </div>
        <div className={styles.feature}>
          <p className={styles.title}>Expenses App</p>
          <img src={expenses} alt="img" />
          <div className={styles.buttonContainer}>
            <Button
              color="red"
              href="https://expenses-app-mohamedmagdy.netlify.app/"
              target="_blank"
            >
              Live demo
            </Button>
            <Button
              href="https://github.com/Mohamed1442/Kalbonyan-Elmarsos/tree/main/02-Udemy/-03-Reactjs-Maximilian/Projects/Expenses-app/S05-project"
              target="_blank"
            >
              Source code
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;

// <nav className={styles.features}>
//         <a>HTML & CSS</a>
//         <a onClick={jsHandler}>JavaScript</a>
//         <a onClick={reactHandler}>React</a>
//         <a>NodeJs</a>
//       </nav>
